import { Injectable } from '@angular/core';
import { environment } from '@env/insitestore360';


@Injectable({
    providedIn: 'root'
})
export class CspService {

    constructor() { }

    getCspPolicy(): string {
        const config = environment.cspConfig;

        return [
            `default-src 'self'`,
            `script-src ${config.scriptSrc}`,
            `worker-src 'self' blob: https://cdn.jsdelivr.net`,
            `style-src ${config.styleSrc}`,
            `font-src ${config.fontSrc}`,
            `img-src ${config.imgSrc}`,
            `media-src ${(config as any)?.mediaSrc || "'self' data: https: blob:"}`,
            `connect-src ${config.connectSrc}`,
            `frame-src ${config.frameSrc}`,
            `base-uri ${config.baseUri}`,
            `form-action ${config.formAction}`
        ].join('; ');
    }

    applyCspPolicy(): void {
        const cspPolicy = this.getCspPolicy();

        // Remove existing CSP meta tag
        const existingCsp = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
        if (existingCsp) {
            existingCsp.remove();
        }

        // Create new CSP meta tag
        const meta = document.createElement('meta');
        meta.setAttribute('http-equiv', 'Content-Security-Policy');
        meta.setAttribute('content', cspPolicy);

        // Add to head
        document.head.appendChild(meta);
    }
}
